module.exports = __webpack_public_path__ + "img/eq-girdle.bdb7daaa.png";